import { Component, OnInit, ElementRef, ViewChildren, QueryList, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { HeroSectionComponent } from '@core/components/hero-section/hero-section.component';
import { ContactSectionComponent } from '@core/components/contact-section/contact-section.component';
import { ProblemsSectionComponent } from '@core/components/problems-section/problems-section.component';
import { TestimonialsSectionComponent } from '@core/components/testimonials-section/testimonials-section.component';
import { FinanceEducationPlanComponent } from '@core/components/finance-education-plan/finance-education-plan.component';
import { UspSectionComponent } from '../../core/components/usp-section/usp-section.component';
import { HesitationSectionComponent } from '../../core/components/hesitation-section/hesitation-section.component';
import { CommitmentSectionComponent } from '@core/components/commitment-section/commitment-section.component';
import { TestimonialSectionComponent } from '@core/components/testimonial-section/testimonial-section.component';
import { DoubtSectionComponent } from '../../core/components/doubt-section/doubt-section.component';
import { FaqComponent } from '../../pages/faq/faq.component';
import { DisclaimerBannerComponent } from '@core/components/disclaimer-banner/disclaimer-banner.component';
interface TickerItem {
  icon: string;
  name: string;
  symbol: string;
  price: number;
  change: number;
}

@Component({
    standalone: true,
    selector: 'app-home',
    imports: [
      CommonModule,
      MatButtonModule,
      RouterModule,
      MatIconModule,
      HeroSectionComponent,
      ContactSectionComponent,
      ProblemsSectionComponent,
      TestimonialsSectionComponent,
      FinanceEducationPlanComponent,
      UspSectionComponent,
      HesitationSectionComponent, 
      CommitmentSectionComponent,
      TestimonialSectionComponent,
      DoubtSectionComponent,  
      FaqComponent,
      DisclaimerBannerComponent,
    ],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChildren('animatedElement') animatedElements!: QueryList<ElementRef>;

  private observer: IntersectionObserver | null = null;
  private isBrowser: boolean;

  tickerItems: TickerItem[] = [
    { icon: 'eth', name: 'Ethereum', symbol: 'ETH', price: 3670.88, change: -1.54 },
    { icon: 'usdt', name: 'Tether', symbol: 'USDT', price: 0.95, change: 0.01 },
    { icon: 'xrp', name: 'XRP', symbol: 'XRP', price: 2.28, change: -1.00 },
    { icon: 'sol', name: 'Solana', symbol: 'SOL', price: 207.59, change: -2.18 },
    { icon: 'bnb', name: 'BNB', symbol: 'BNB', price: 675.22, change: -1.81 },
    { icon: 'doge', name: 'Dogecoin', symbol: 'DOGE', price: 0.372807, change: -2.54 },
    { icon: 'usdc', name: 'USDC', symbol: 'USDC', price: 0.95, change: 0.02 },
    { icon: 'ada', name: 'Cardano', symbol: 'ADA', price: 1.28, change: -1.92 }
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.setupIntersectionObserver();
    }
  }

  private setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target as HTMLElement;
          element.classList.add('animate');
          this.observer?.unobserve(element);
        }
      });
    }, options);
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      setTimeout(() => {
        this.animatedElements?.forEach(({ nativeElement }) => {
          if (nativeElement) {
            this.observer?.observe(nativeElement);
          }
        });
      }, 100);
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
